/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { GoogleProtobufDurationFromJSON, GoogleProtobufDurationToJSON, } from './';
export function StreemApiArtifactRecordingFromJSON(json) {
    return StreemApiArtifactRecordingFromJSONTyped(json, false);
}
export function StreemApiArtifactRecordingFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'bucket': !exists(json, 'bucket') ? undefined : json['bucket'],
        'filename': !exists(json, 'filename') ? undefined : json['filename'],
        'storageUrl': !exists(json, 'storage_url') ? undefined : json['storage_url'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'requestedAt': !exists(json, 'requested_at') ? undefined : (new Date(json['requested_at'])),
        'startedTransferringAt': !exists(json, 'started_transferring_at') ? undefined : (new Date(json['started_transferring_at'])),
        'erroredAt': !exists(json, 'errored_at') ? undefined : (new Date(json['errored_at'])),
        'fulfilledAt': !exists(json, 'fulfilled_at') ? undefined : (new Date(json['fulfilled_at'])),
        'createdAt': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'url': !exists(json, 'url') ? undefined : json['url'],
        'recordingSource': !exists(json, 'recording_source') ? undefined : json['recording_source'],
        'previewStorageUrl': !exists(json, 'preview_storage_url') ? undefined : json['preview_storage_url'],
        'previewUrl': !exists(json, 'preview_url') ? undefined : json['preview_url'],
        'duration': !exists(json, 'duration') ? undefined : GoogleProtobufDurationFromJSON(json['duration']),
        'recordingStatus': !exists(json, 'recording_status') ? undefined : json['recording_status'],
        'deletedAt': !exists(json, 'deleted_at') ? undefined : (new Date(json['deleted_at'])),
    };
}
export function StreemApiArtifactRecordingToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'bucket': value.bucket,
        'filename': value.filename,
        'storage_url': value.storageUrl,
        'status': value.status,
        'requested_at': value.requestedAt === undefined ? undefined : (value.requestedAt.toISOString()),
        'started_transferring_at': value.startedTransferringAt === undefined ? undefined : (value.startedTransferringAt.toISOString()),
        'errored_at': value.erroredAt === undefined ? undefined : (value.erroredAt.toISOString()),
        'fulfilled_at': value.fulfilledAt === undefined ? undefined : (value.fulfilledAt.toISOString()),
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'url': value.url,
        'recording_source': value.recordingSource,
        'preview_storage_url': value.previewStorageUrl,
        'preview_url': value.previewUrl,
        'duration': GoogleProtobufDurationToJSON(value.duration),
        'recording_status': value.recordingStatus,
        'deleted_at': value.deletedAt === undefined ? undefined : (value.deletedAt.toISOString()),
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiArtifactRecordingStatus;
(function (StreemApiArtifactRecordingStatus) {
    StreemApiArtifactRecordingStatus["ERROR"] = "STATUS_ERROR";
    StreemApiArtifactRecordingStatus["FULFILLED"] = "STATUS_FULFILLED";
    StreemApiArtifactRecordingStatus["INVALID"] = "STATUS_INVALID";
    StreemApiArtifactRecordingStatus["REQUESTED"] = "STATUS_REQUESTED";
    StreemApiArtifactRecordingStatus["TRANSFERRING"] = "STATUS_TRANSFERRING";
})(StreemApiArtifactRecordingStatus || (StreemApiArtifactRecordingStatus = {}));
/**
* @export
* @enum {string}
*/
export var StreemApiArtifactRecordingRecordingSource;
(function (StreemApiArtifactRecordingRecordingSource) {
    StreemApiArtifactRecordingRecordingSource["ARAAS"] = "SOURCE_ARAAS";
    StreemApiArtifactRecordingRecordingSource["CHIME"] = "SOURCE_CHIME";
    StreemApiArtifactRecordingRecordingSource["INVALID"] = "SOURCE_INVALID";
    StreemApiArtifactRecordingRecordingSource["ONDEVICE"] = "SOURCE_ON_DEVICE";
    StreemApiArtifactRecordingRecordingSource["TWILIO"] = "SOURCE_TWILIO";
})(StreemApiArtifactRecordingRecordingSource || (StreemApiArtifactRecordingRecordingSource = {}));
/**
* @export
* @enum {string}
*/
export var StreemApiArtifactRecordingRecordingStatus;
(function (StreemApiArtifactRecordingRecordingStatus) {
    StreemApiArtifactRecordingRecordingStatus["NONE"] = "RECORDING_STATUS_NONE";
    StreemApiArtifactRecordingRecordingStatus["PAUSED"] = "RECORDING_STATUS_PAUSED";
    StreemApiArtifactRecordingRecordingStatus["RESUMED"] = "RECORDING_STATUS_RESUMED";
    StreemApiArtifactRecordingRecordingStatus["TEMPORARYFAILURE"] = "RECORDING_STATUS_TEMPORARY_FAILURE";
    StreemApiArtifactRecordingRecordingStatus["INVALID"] = "RECORDING_STATUS_INVALID";
})(StreemApiArtifactRecordingRecordingStatus || (StreemApiArtifactRecordingRecordingStatus = {}));
//# sourceMappingURL=StreemApiArtifactRecording.js.map